// extracted by mini-css-extract-plugin
export default {"container":"NewChat_container__bQ5rU","text-light":"NewChat_text-light__VDBm-"};